/**
 * Идентификатор статуса процесса в ERP
 */
export const PROCESS_STATUS = {
  OPENED: 10,
  CHOICE_CONTRACT: 453,
  CHOICE_SERVICES: 451,
  CHOICE_SERVICES_WITH_CODE_PHRASE: 450,
  CLOSED_WITHOUT_SUPPORT: 179,
  AWAIT_DEPARTURE: 419,
  AWAIT_PAYMENT: 226,
  AWAIT_SIGNING: 283,
  CONTRACT_EXIST: 409,
  CHANGE_PHONE_NUMBER: 443,
  CHOICE_DEPARTURE_TIME: 424,
};
